import { useEffect, useState } from 'react';
// import axios from '@/services/axiosInstance';
import axiosInstance from "../../helpers/Axios";
import TeamForm from '../../components/Admin/TeamForm';
import '../../css/team/admin.scss';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

type TeamMember = {
  teamId: number;
  firstName: string;
  lastName: string;
  imageUrl?: string;
  description: string;
};

const AdminTeam = () => {
  const [members, setMembers] = useState<TeamMember[]>([]);
  const [editing, setEditing] = useState<TeamMember | null>(null);

  const load = async () => {
    const res = await axiosInstance.get('/team');
    setMembers(res.data);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="admin-page">
      <div id="title">
        <h1>Administration – Équipe</h1>
      </div>
      <div id="content">
        <div className="admin-actions">
          <button onClick={() =>
            setEditing({
              teamId: 0,
              firstName: '',
              lastName: '',
              description: '',
              imageUrl: undefined
            })
          }>
            ➕ Ajouter une personne
          </button>
        </div>

        <div className="admin-list">
          {/* liste des personnes */}
          <Table className="stage-list">
            <TableHead>
              <TableRow>
                <TableCell>Membre</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members.map(m => (
                <TableRow key={m.teamId}>
                  <TableCell>{m.firstName} {m.lastName}</TableCell>
                  <TableCell>
                    <button onClick={() => setEditing(m)}>✏️ Modifier</button>
                    <button onClick={() => axiosInstance.delete(`/team/${m.teamId}`).then(load)}>🗑️ Supprimer</button>
                  </TableCell>
                </TableRow>
              ))}

            </TableBody>
          </Table>
        </div>
        {editing && (
          <TeamForm
            member={editing}
            onClose={() => setEditing(null)}
            onSaved={load}
          />
        )}
      </div>

    </div>

  );
};

export default AdminTeam;